import React, { useState, useEffect } from "react";
import Icon from "components/Icon";

const SearchInput = ({ 
  placeholder,
  data,
  filterKeys,
  onResults,
  className = '',
  id,
  dataCy,
  disabled = false,
  value = '',
  onChange = null
}) => {
  const [searchText, setSearchText] = useState(value || '');

  const getNestedValue = (obj, path) => {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
  };

  const filterData = (query) => {
    const trimmed = query.trim().toLowerCase();

    if (!trimmed) {
      onResults(data);
      return;
    }

    const filtered = data.filter((item) =>
      filterKeys.some((key) => {
        let value = getNestedValue(item, key);
        
        // Convert to string first, then replace underscores and hyphens with spaces
        if (value !== null && value !== undefined) {
          value = value.toString().replace(/_|-/g, ' ');
        }
        
        return value?.toLowerCase().includes(trimmed);
      })
    );

    onResults(filtered);
  };

  useEffect(() => {
    // sync controlled value -> internal state
    setSearchText(value || '');
  }, [value]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      filterData(searchText);
    }, 200); // Slightly faster debounce

    return () => clearTimeout(timeout);
  }, [searchText, data]);

  const handleChange = (e) => {
    const value = e.target.value;

    setSearchText(value);

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={`flex items-center px-5 py-3 bg-[var(--color-glass-dark)] rounded-[100px] border border-[var(--color-gray-100)] tw-input-wrapper ${className}`}>
      <Icon name="search" size={20} className="text-[var(--color-gray-800)]" />
      <input
        id={id}
        data-cy={dataCy}
        type="text"
        disabled={disabled}
        className="tw-paragraph-reg ml-2 w-full outline-none"
        placeholder={placeholder}
        value={searchText}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchInput;
